'use client'

import { useSearchParams } from 'next/navigation'
import { useTranslations } from 'next-intl'

import { DateRange, useFormatDate } from '@/shared/lib'
import { TextButton } from '@/shared/ui'
import {
  DATE_FORMAT,
  getDefaultPeriod,
  useContractPeriod,
} from '@/widgets/contract-calendar'

type Props = {
  period?: DateRange
  disabled?: boolean
  onClick: () => void
}

export const PeriodTextButton = ({
  onClick,
  disabled,
  period: periodProp,
}: Props) => {
  const t = useTranslations('room_detail')

  const { formatDateWithDayOfWeek } = useFormatDate()

  const searchParams = useSearchParams()

  const contractPeriod = useContractPeriod({
    defaultPeriod: getDefaultPeriod(searchParams),
  })

  const period = periodProp || contractPeriod.period

  if (!period.from || !period.to) {
    return (
      <TextButton
        size="large"
        underline
        color="gray"
        onClick={onClick}
        disabled={disabled}
      >
        {t('button.check_available_date')}
      </TextButton>
    )
  }

  return (
    <TextButton
      size="large"
      underline
      color="gray"
      onClick={onClick}
      disabled={disabled}
    >
      {formatDateWithDayOfWeek({
        date: period.from,
        format: DATE_FORMAT,
      })}{' '}
      ~{' '}
      {formatDateWithDayOfWeek({
        date: period.to,
        format: DATE_FORMAT,
      })}
    </TextButton>
  )
}
